import { API } from "./api";

export const register = (newUser) => API.post("/users/register", newUser);

export const login = async (email, password) => {
  try {
    const response = await API.post("/users/login", { email, password });
    const token = response?.data?.token;
    if (token) {
      localStorage.setItem("token", token);
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export const getCurrentUser = () => API.get("users/me");
